import { TitleCasePipe } from '@angular/common';
import { Component, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbInputDatepicker, NgbModal, NgbTooltip, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, merge } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EnterpriseSearchService,
  ServiceType,
  UserService
} from '@sabstravtech/obtservices/angular';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

import { DeviceDetector } from '../../../core/services/device-detector.service';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-irl-results',
  templateUrl: './irl-results.component.html',
  styleUrls: ['./irl-results.component.scss'],
  standalone: false
})
export class IrlResultsComponent implements OnInit {
  @ViewChild('instance') instance: NgbTypeahead;
  @ViewChild('ttip') ttip: NgbTooltip;
  ServiceType: typeof ServiceType = ServiceType;
  constructor(
    private userService: UserService,
    private readonly router: Router,
    public deviceDetector: DeviceDetector,
    public searchService: EnterpriseSearchService,
    private titleCasePipe: TitleCasePipe,
    private title: Title,
    private route: ActivatedRoute,
    public translateService: TranslateService,
    public themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.title.setTitle(
      this.translateService.instant(
        `European Rail Results ${this.themeService.isLightningEnv ? ' - LightUk' : ''}`
      )
    );
  }
}
